import { AfterViewInit, ChangeDetectorRef, Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';

import { AXDialogService } from '@acorex/components/dialog';
import { AXFormComponent } from '@acorex/components/form';
import { AXBasePageComponent } from '@acorex/components/page';
import { CommonModule } from '@angular/common';
import { CaptchaOutputModel, SettingDataOutputModel } from '@travel/shared';
import { DataConfig } from '@travel/shared/services';
import { PublicRegisterService } from './public-register.service';

import { AXButtonModule } from '@acorex/components/button';
import { AXDecoratorModule } from '@acorex/components/decorators';
import { AXDropdownModule } from '@acorex/components/dropdown';
import { AXFormModule } from '@acorex/components/form';
import { AXLabelModule } from '@acorex/components/label';
import { AXLoadingModule } from '@acorex/components/loading';
import { AXPasswordBoxModule } from '@acorex/components/password-box';
import { AXTextBoxModule } from '@acorex/components/text-box';
import { AXTranslationModule, AXTranslationService } from '@acorex/core/translation';

const AcorexModules: any[] = [AXButtonModule, AXDropdownModule, AXDecoratorModule, AXTextBoxModule, AXFormModule, AXLabelModule, AXPasswordBoxModule, AXLoadingModule, AXTranslationModule];

@Component({
  selector: 'travel-btc-workspace-public-register',
  standalone: true,
  imports: [CommonModule, ...AcorexModules],
  templateUrl: './public-register.component.html',
  styleUrl: './public-register.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [PublicRegisterService],
})
export class PublicRegisterComponent extends AXBasePageComponent implements AfterViewInit {
  _changeDetectorRef = inject(ChangeDetectorRef);
  protected translateService = inject(AXTranslationService);

  _captchaCodeObject: CaptchaOutputModel = {};
  _captchLoading = false;
  settingData: SettingDataOutputModel = DataConfig.get('globalSetting');

  _registerObj: any = {};

  forgotPasswordFlag!: number;

  activationCode = false;

  tokenId!: string;

  submit = true;
  resend = false;
  continue = false;
  firstStep = true;
  nextStep = false;

  // timer
  second!: number;
  timer!: any;
  countReSend = 0;
  loading = false;

  @ViewChild('registerForm') registerForm!: AXFormComponent;
  constructor(private _publicRegisterService: PublicRegisterService, private _dialogService: AXDialogService) {
    super();
  }

  ngAfterViewInit(): void {
    this.getCaptchaGenerate();
  }

  getCaptchaGenerate() {
    if (!this.isLoading) {
      this.isLoading = true;
    }

    this._publicRegisterService
      .captchaGenerate()
      .then((res) => {
        this._captchaCodeObject = res;
      })
      .finally(() => {
        this.isLoading = false;
        this._changeDetectorRef.markForCheck();
      });
  }

  onSubmitClick() {
    this.registerForm.validate().then((isValid) => {
      if (isValid.result) {
        if (this.forgotPasswordFlag === 1 && this._registerObj.password !== this._registerObj.passwordConfirm) {
          // کلمه‌ عبور و تکرار آن باید یکسان باشند
          this._dialogService.alert(this.translateService.translateSync('common.attention'), this.translateService.translateSync('profile.samePassword'), 'danger').then(() => {
            this.getCaptchaGenerate();
          });
          return;
        }

        const params: any = {
          username: this._registerObj.username,
          captchaCode: this._registerObj.captchaCode,
          captchaId: this._captchaCodeObject.id,
          forgotPasswordFlag: this.forgotPasswordFlag,
        };
        if (!this.isLoading) {
          this.isLoading = true;
        } else {
          return;
        }
        this._publicRegisterService
          .dyanimcLoginFirstStep(params)
          .then((res: any) => {
            this.tokenId = res.tokenId;
            this.activationCode = true;
            this.submit = false;
            this.resend = false;
            this.continue = true;
            this.second = 120; //120
            this.timer = setInterval(() => {
              this.second = this.counter(this.second);
              this._changeDetectorRef.detectChanges();
              if (this.second === 0) {
                this.continue = false;
                this.resend = true;
                this._registerObj.captchaCode = null;
                this.getCaptchaGenerate();
                clearInterval(this.timer);
                this.resend = true;
              }
            }, 1000);
          })
          .catch((error: any) => {
            // خطا در برقراری ارتباط',
            this._dialogService
              .alert(this.translateService.translateSync('common.attention'), error.error.error_description || this.translateService.translateSync('common.connectionError'), 'danger')
              .then(() => {
                this._registerObj.captchaCode = null;
                this.getCaptchaGenerate();
              });
          })
          .finally(() => (this.isLoading = false));
      } else {
        console.log('error');
      }
    });
  }

  onReSendCodeClick() {
    this.registerForm.validate().then((isValid) => {
      if (isValid.result) {
        this._registerObj.captchaCode = null;
        this.getCaptchaGenerate();
        this.resend = false;
        this.continue = true;
        this.second = 120;
        this.timer = setInterval(() => {
          this.second = this.counter(this.second);
          this._changeDetectorRef.detectChanges();
          if (this.second === 0) {
            this._registerObj.captchaCode = null;
            this.getCaptchaGenerate();
            clearInterval(this.timer);
            this.resend = true;
          }
        }, 1000);
        const params: any = {
          username: this._registerObj.username,
          captchaCode: this._registerObj.captchaCode,
          captchaId: this._captchaCodeObject.id,
          forgotPasswordFlag: this.forgotPasswordFlag,
        };

        if (!this.isLoading) {
          this.isLoading = true;
        } else {
          return;
        }

        this._publicRegisterService
          .dyanimcLoginFirstStep(params)
          .then((res: any) => {
            this.tokenId = res.tokenId;
            this.activationCode = true;
            this.submit = false;
            this.continue = true;
          })
          .catch((error: any) => {
            this._registerObj.captchaCode = null;
            this.getCaptchaGenerate();
            this._dialogService.alert(this.translateService.translateSync('common.attention'), error.error.error_description, 'danger');
          })
          .finally(() => (this.isLoading = false));
      }
    });
  }

  onRegisterClick(): void {
    this.registerForm.validate().then((isValid) => {
      if (isValid.result) {
        const params = {
          username: this._registerObj.username,
          userPassword: this.forgotPasswordFlag !== 1 ? this._registerObj.activationCode : this._registerObj.password,
          password: this._registerObj.activationCode,
          tokenId: this.tokenId,
          forgotPasswordFlag: this.forgotPasswordFlag || null,
        };
        if (this._registerObj.password !== this._registerObj.passwordConfirm) {
          // کلمه‌ عبور و تکرار آن باید یکسان باشند
          this._dialogService.alert(this.translateService.translateSync('common.attention'), this.translateService.translateSync('profile.samePassword'), 'danger');
        } else {
          if (!this.isLoading) {
            this.isLoading = true;
          } else {
            return;
          }

          this._publicRegisterService
            .dynamicLoginNextStep(params)
            .then(() => {
              // کلمه عبور با موفقیت تغییر کرد....حساب کاربری شما با موفقیت ایجاد شد
              const message = params.forgotPasswordFlag ? this.translateService.translateSync('profile.changePasswordSuccess') : this.translateService.translateSync('profile.accountCreate');
              this._dialogService.alert(this.translateService.translateSync('common.congratulations'), message, 'success').then(() => {
                this.close();
              });
              document.location.reload();
            })
            .catch((error: any) => {
              // توجه
              this._dialogService.alert(this.translateService.translateSync('common.attention'), error.error.error_description, 'danger').then(() => {
                this._registerObj.captchaCode = null;
                this.getCaptchaGenerate();
              });
            })
            .finally(() => (this.isLoading = false));
        }
      }
    });
  }

  counter = (s: any) => {
    return s - 1;
  };

  onErrorHandle() {
    switch (this.settingData.registerMethodTypeId) {
      case 1:
        return this.translateService.translateSync('profile.mobileWhitZero');
      case 2:
        
        return this.translateService.translateSync('profile.emailIncorrect');

      default:
        return this.translateService.translateSync('profile.mobileWhitZero');
    }
  }
}
